import { companyInfo } from "@/config/constants";

export function LeftPanel() {
  return (
    <div className="hidden lg:flex lg:flex-col bg-primary text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 ">
        <img
          src="/assets/bg-auth.png"
          alt="background"
          className="size-full object-contain mix-blend-multiply"
        />
      </div>

      <div className="relative z-10 flex flex-col justify-between h-full p-12">
        {/* Header */}
         {/* Features */}
        <div className="space-y-8 flex-1 flex flex-col justify-center items-center">
          <div className="text-center">
            <div className="flex items-center gap-3 mb-2 justify-center">
              <div>
                <img src="/assets/logo_text.png" alt="logo" className="h-8 " />
              </div>
            </div>
            <p className="text-white text-4xl font-medium">
              {companyInfo.description}
            </p>
          </div>
          <img src="/assets/login.png" alt="login" className="w-full object-contain max-w-[800px]" />
        </div>

        {/* Footer */}
        <div className="text-green-300 text-sm">© 2025 {companyInfo.name}</div>
      </div>
    </div>
  );
}
